module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk_primærlogo_pos(svart).8dce1460.svg";